import React, { useState, useEffect } from 'react';
import './CaHeader.css';

const SECTION_MAP = [
  { id: 'detailed-courses', key: 'courses' },
  { id: 'tutors',           key: 'tutors'  },
  { id: 'pricing',          key: 'pricing' },
  { id: 'contact',          key: 'contact' },
];

const CaHeader = ({ onOpenModal }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY < 200) {
        setActiveSection('home');
        return;
      }
      const scrollY = window.scrollY + 130;
      let current = 'home';
      for (const { id, key } of SECTION_MAP) {
        const el = document.getElementById(id);
        if (el) {
          const top = el.getBoundingClientRect().top + window.scrollY;
          if (top <= scrollY) {
            current = key;
          }
        }
      }
      setActiveSection(current);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => setIsMobileMenuOpen(prev => !prev);

  const handleCtaClick = (e) => {
    e.preventDefault();
    if (onOpenModal) onOpenModal();
    setIsMobileMenuOpen(false);
  };

  const scrollToSection = (e, targetId) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  const linkClass = (key) =>
    `ca-header__menu-link${activeSection === key ? ' ca-header__menu-link--active' : ''}`;

  return (
    <header className="ca-header">
      <div className="ca-header__container">
        <a href="/ca/" className="ca-header__logo-container" aria-label="Al Quran Lesson">
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
            alt="Al Quran Lesson"
            className="ca-header__logo-image"
          />
        </a>

        <div className="ca-header__right-group">
          <nav className="ca-header__nav">
            <ul className="ca-header__menu">
              <li className="ca-header__menu-item">
                <a href="/ca/" className={linkClass('home')}>Home</a>
              </li>
              <li className="ca-header__menu-item">
                <a href="#detailed-courses" onClick={(e) => scrollToSection(e, 'detailed-courses')} className={linkClass('courses')}>Courses</a>
              </li>
              <li className="ca-header__menu-item">
                <a href="#tutors" onClick={(e) => scrollToSection(e, 'tutors')} className={linkClass('tutors')}>Tutors</a>
              </li>
              <li className="ca-header__menu-item">
                <a href="#pricing" onClick={(e) => scrollToSection(e, 'pricing')} className={linkClass('pricing')}>Pricing</a>
              </li>
              <li className="ca-header__menu-item">
                <a href="#contact" onClick={(e) => scrollToSection(e, 'contact')} className={linkClass('contact')}>Contact</a>
              </li>
            </ul>
          </nav>

          <div className="ca-header__cta">
            <button onClick={handleCtaClick} className="ca-header__btn" style={{ border: 'none', cursor: 'pointer' }}>
              Book Your 3-Day Free Trial
            </button>
          </div>
        </div>

        <button className="ca-header__mobile-toggle" onClick={toggleMobileMenu} aria-label="Toggle Navigation Menu">
          <span className={`ca-header__hamburger ${isMobileMenuOpen ? 'ca-header__hamburger--open' : ''}`}></span>
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className="ca-header__mobile-menu">
          <ul>
            <li><a href="/ca/" onClick={() => setIsMobileMenuOpen(false)}>Home</a></li>
            <li><a href="#detailed-courses" onClick={(e) => scrollToSection(e, 'detailed-courses')}>Courses</a></li>
            <li><a href="#tutors" onClick={(e) => scrollToSection(e, 'tutors')}>Tutors</a></li>
            <li><a href="#pricing" onClick={(e) => scrollToSection(e, 'pricing')}>Pricing</a></li>
            <li><a href="#contact" onClick={(e) => scrollToSection(e, 'contact')}>Contact</a></li>
            <li>
              <button onClick={handleCtaClick} className="ca-header__btn ca-header__btn--mobile" style={{ border: 'none', cursor: 'pointer', width: '100%' }}>
                Book Your 3-Day Free Trial
              </button>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default CaHeader;
